import { useMemo } from "react";
import { useIntl } from "react-intl";
import PrimeReactMessages from "core/shared/intl/PrimeReactMessages";

/**
 * Internationalizes the "currentPageReportTemplate" of a PrimeReact DataTable Paginator.
 * @returns {string} Returns "{first} to {last} of {totalRecords}"
 */
const useCurrentPageReportTemplate = () => {
  const { formatMessage } = useIntl();

  const currentPageReportTemplate = useMemo(() => {
    const to = formatMessage(PrimeReactMessages.to);
    const of = formatMessage(PrimeReactMessages.of);
    return `{first} ${to} {last} ${of} {totalRecords}`;
  }, [formatMessage]);

  return currentPageReportTemplate;
};

export default useCurrentPageReportTemplate;
